/**
 * HeaderPanel.tsx — utvidbart panel under header
 *
 * Ren React-komponent som erstatter cds-header-panel.
 * Vises under header når tilknyttet global action er aktiv.
 *
 * Props:
 * - expanded: om panelet er utvidet
 * - ariaLabel (valgfri): navn på region-landmarket — påkrevd for a11y
 *   (Carbon-audit: role="region" krever aria-label for identifikasjon)
 * - children: panel-innhold
 */

import { ReactNode } from 'react';
import styles from './header-panel.module.css';

interface HeaderPanelProps {
  expanded: boolean;
  ariaLabel?: string;
  children: ReactNode;
}

export default function HeaderPanel({
  expanded,
  ariaLabel,
  children,
}: HeaderPanelProps) {
  if (!expanded) return null;
  return (
    <div className={styles.panel} role="region" aria-label={ariaLabel}>
      {children}
    </div>
  );
}
